import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PlantillaDetalle, PlantillaPayload, PlantillaResumen } from './plantilla.model';

@Injectable({ providedIn: 'root' })
export class GestionPlantillasService {

  private readonly API_URL: string = environment.API_URL;

  constructor(private http: HttpClient) {}

  list(): Observable<PlantillaResumen[]> {
    return this.http.get<PlantillaResumen[]>(`${this.API_URL}/plantilla/list`);
  }

  /** Plantillas activas (formato mínimo) para el selector de la remesa. */
  activas(): Observable<{ id: number; nombre: string }[]> {
    return this.http.get<{ id: number; nombre: string }[]>(`${this.API_URL}/plantilla/activas`);
  }

  get(id: number): Observable<PlantillaDetalle> {
    return this.http.get<PlantillaDetalle>(`${this.API_URL}/plantilla/${id}`);
  }

  /** Campos estándar disponibles para usar como placeholders. */
  campos(): Observable<string[]> {
    return this.http.get<string[]>(`${this.API_URL}/plantilla/campos`);
  }

  save(p: PlantillaPayload): Observable<any> {
    return p.id
      ? this.http.post(`${this.API_URL}/plantilla/save/${p.id}`, p)
      : this.http.post(`${this.API_URL}/plantilla/save`, p);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.API_URL}/plantilla/${id}`);
  }
}
